import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/licenseRenewalSetupFee/main"));


const LicenseRenewalSetUpFee = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>

        
    
  );
};

export default LicenseRenewalSetUpFee;




